import { useModuleSwitches } from '../../contexts/ModuleSwitchContext.jsx'
import { isModuleReleased } from '../constants/modules'

/**
 * Whether this company has `moduleId`, by the server's switches (contexts/ModuleSwitchContext.jsx) and
 * each module's own rule (shared/constants/modules.js isModuleReleased).
 *
 * For a page in a module that stays ON which also shows a piece of another module: with that module
 * switched off its service refuses the read, so the piece is hidden or replaced by <SwitchedOffNote>,
 * never left to say "Not Found" or show a dash that reads like a zero.
 */
export const useModuleOn = (moduleId) => isModuleReleased(moduleId, useModuleSwitches().switches)
